// Single source of truth for all pricing plans and Stripe Price IDs.
// Credit-system permissions are derived from this file.

export interface Plan {
  name: string;
  slug: "free" | "starter" | "pro";
  monthlyPrice: number;
  annualPrice: number; // effective per-month price on annual billing
  monthlyPriceId: string;
  annualPriceId: string;
  credits: number;
  dailyCredits: number;
  features: string[];
  imageTransforms: boolean;
  apiAccess: boolean;
  rollover: boolean;
  popular?: boolean;
}

export const plans: Plan[] = [
  {
    name: "Free",
    slug: "free",
    monthlyPrice: 0,
    annualPrice: 0,
    monthlyPriceId: "",
    annualPriceId: "",
    credits: 25,
    dailyCredits: 0,
    features: ["25 credits on signup", "All 6 creative voices", "Text transforms only"],
    imageTransforms: false,
    apiAccess: false,
    rollover: false,
  },
  {
    name: "Starter",
    slug: "starter",
    monthlyPrice: 12,
    annualPrice: 10,
    monthlyPriceId: "price_1TMsaSFo6WywDDQrlhkDJO6t",
    annualPriceId: "price_1TMsbsFo6WywDDQrmsBNCEDi",
    credits: 200,
    dailyCredits: 5,
    features: [
      "200 monthly credits, 5 daily credits",
      "All 6 creative voices",
      "Text + image transforms",
    ],
    imageTransforms: true,
    apiAccess: false,
    rollover: false,
    popular: true,
  },
  {
    name: "Pro",
    slug: "pro",
    monthlyPrice: 29,
    annualPrice: 23,
    monthlyPriceId: "price_1TJymtFo6WywDDQrUZZctZCW",
    annualPriceId: "price_1TKPF9Fo6WywDDQrTHljy5Nt",
    credits: 800,
    dailyCredits: 10,
    features: [
      "800 monthly credits, 10 daily credits",
      "50% credit rollover",
      "All 6 creative voices",
      "Text + image transforms",
      "Custom Brand Voice - auto-applies to every transform",
      "API access",
    ],
    imageTransforms: true,
    apiAccess: true,
    rollover: true,
  },
];

export interface CreditTopup {
  credits: number;
  price: number;
  priceId: string;
}

export const CREDIT_TOPUPS: CreditTopup[] = [
  { credits: 100, price: 10, priceId: "price_1TLRv7Fo6WywDDQrYIR065DS" },
  { credits: 250, price: 20, priceId: "price_1TMsrkFo6WywDDQrJQu4RnUY" },
  { credits: 500, price: 35, priceId: "price_1TMsvPFo6WywDDQrTBHdgLdn" },
];

/** @deprecated Use CREDIT_TOPUPS[0].priceId instead */
export const CREDIT_TOPUP_PRICE_ID = CREDIT_TOPUPS[0].priceId;

export const getPlan = (slug: Plan["slug"]) => plans.find((p) => p.slug === slug)!;

export const allowsImageTransforms = (tier: string | undefined | null): boolean => {
  if (!tier) return false;
  const plan = plans.find((p) => p.slug === tier);
  return plan?.imageTransforms ?? false;
};

export const allowsApiAccess = (tier: string | undefined | null): boolean => {
  if (!tier) return false;
  const plan = plans.find((p) => p.slug === tier);
  return plan?.apiAccess ?? false;
};
